export default class EvalApi {
    static apiBase = '/api/questionnaires';

    static getQuestionnaire({ guid, siteId }) {
        return fetch(`${this.apiBase}/${guid}?siteId=${siteId}`);
    }

    static submitQuestionnaire({ guid, data }) {
        return fetch(`${this.apiBase}/${guid}/answers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
}